export const Airports = [
    {
        airport: "IKA",
    },
    {
        airport: "",
    }]